import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import alm from "./aluminum.png"
import cupper from "./cupper.png"

const メタル材質 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { metalBoard: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} helpURL={HELP_LINKS.メタル材質} legend="メタル材質">
      <RadioGroup name={FIELD_NAMES.メタル材質} selectedValue={values.metalBoard} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.メタル材質.アルミ.value} prefixImageSrc={alm}>
            アルミ
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.メタル材質.銅.value} prefixImageSrc={cupper}>
            銅
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.metalBoard} />
    </OneClickField>
  )
}

export default メタル材質
